import * as classNames from 'classnames';
import * as React from 'react';

export const Icon: React.SFC<IconProps> = ({name, spin, className, onClick, size, color, margin, title, hoverColor}) => (
  <span title={title}
        className={classNames('icon fa', `fa-${name}`, className, {'fa-spin': spin})}
        style={{

          fontSize: size, margin, color,
          "&:hover": {
            color:hoverColor
          },
        
        }}
        onClick={onClick}/>
);

export const CustomIcon2: React.SFC<{
  title: string;
  path: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
}> = ({ title, path, onClick }) => (
  <img className='custom-icon-app-page' 
  src={path} title={title} onClick={onClick} />
);

export const CustomIcon: React.SFC<{
  title: string;
  path: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
}> = ({ title, path, onClick }) => (
  <img className='custom-icon' src={path} title={title} onClick={onClick} />
);

interface IconProps {
  name: string;
  title?: string;
  spin?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  size?: number | string;
  color?: string;
  margin?: number | string;
  hoverColor?:string;
}

Icon.defaultProps = {
  color: 'black',
  margin: 5,
  size: '1rem',
  spin: false,
  hoverColor:'red',
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/widgets/Icon/index.tsx